import { render, staticRenderFns } from "./MatterIntroduction.vue?vue&type=template&id=299e9ce6&scoped=true&"
import script from "./MatterIntroduction.vue?vue&type=script&lang=js&"
export * from "./MatterIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./MatterIntroduction.vue?vue&type=style&index=0&id=299e9ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e9ce6",
  null
  
)

export default component.exports